import type { ReactNode } from "react";
import { Button } from "@simplybusiness/mobius";
import { useInsuranceAdvisor } from "../../../contexts/InsuranceAdvisorProvider";

export type CoverageButtonProps = {
  productCode?: string;
  onClick: (e: React.MouseEvent) => void;
  className?: string;
  children?: ReactNode;
};

export const CoverageButton = ({
  productCode,
  onClick,
  className,
  children = "See what\u2019s covered",
}: CoverageButtonProps) => {
  const { getAdvisorAttributes } = useInsuranceAdvisor();

  const validatedInsuranceAdvisorData = productCode
    ? getAdvisorAttributes(productCode)
    : undefined;

  const advisorClassName = validatedInsuranceAdvisorData
    ? [className, "sb-iaw reco-agent-ai-button"].filter(Boolean).join(" ")
    : className;

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (!validatedInsuranceAdvisorData) {
      onClick(e);
    }
    // If validatedInsuranceAdvisorData exists, the widget will handle the click
  };

  return (
    <Button
      size="sm"
      type="button"
      variant="ghost"
      onClick={handleClick}
      className={advisorClassName}
      {...validatedInsuranceAdvisorData}
    >
      {children}
    </Button>
  );
};
